import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import CdnImage from "../../components/image/CdnImage";
import { S3URL } from "../../utils/conf";

export const WriteYourQuestion = () => {
  const { t } = useTranslation();
  const navi = useNavigate();
  const { setShowLoginModal, isAuthenticated } = useAuth();
  const handleClickInquiry = () => {
    if (true || isAuthenticated) {
      navi("/post-inquiry");
    } else {
      setShowLoginModal(true);
    }
  };
  return (
    <>
      <div className="w-full sm:w-1/2">
        <CdnImage
          src={S3URL + "/assets/images/inquiry.png"}
          className="h-full w-full flex-1 rounded-b-none rounded-t-[1.25rem] sm:rounded-e-none sm:rounded-s-[1.25rem]"
          alt="Write your question"
          cdnParams={{
            format: "webp",
            width: 600,
          }}
        />
      </div>
      <div className="flex w-full items-center justify-center rounded-b-[1.25rem] rounded-t-none border bg-[#FCFCFC] py-5 sm:w-1/2 sm:rounded-e-[1.25rem] sm:rounded-s-none sm:py-0">
        <div className="max-w-[390px] content-center p-4 lg:p-0">
          <h2 className="mb-5 px-[0.625rem] text-center text-lg font-semibold leading-[1.625rem] sm:text-[1.5rem] sm:leading-[1.875rem]">
            {t("Resolve your questions through 1:1 inquiries.")}
          </h2>
          <p className="mb-[1.2188rem] text-center text-sm font-normal leading-[1.375rem] text-[#727272] sm:text-base sm:leading-[1.625rem]">
            {t(
              "We will answer all your questions about tours, passes, reservations, cancellations, usage methods, and more!",
            )}
          </p>
          <div
            onClick={handleClickInquiry}
            className="mx-auto flex h-[3.875rem] max-w-[21.25rem] content-center items-center justify-between rounded-full border border-[#DEDEDE] px-[0.375rem]"
          >
            <p className="ml-4 text-sm font-normal text-[#6C757D] sm:ml-[1.9375rem] sm:text-base sm:leading-[1.3619rem]">
              {t("Write your question")}
            </p>
            <button className="min-w-[5.25rem] rounded-[3.125rem] bg-[#232323] py-3 text-center text-sm text-white sm:min-w-[7.0725rem] sm:py-4 sm:text-base sm:leading-[1.25rem]">
              {t("Write")}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
